import { Fragment } from 'react'
import { Box, Typography } from '@mui/material'
import { format } from 'date-fns'
import DayDiv from './dayDiv'

const dayofWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const CalendarBlock = ({
  calendarProps,
  calendar,
  value,
  clickState,
  handleClick,
  selectedFirst,
  selectedSecond,
  setSelectedDisabledCounter,
}) => {
  const getSelectedDisabledCount = (isDisabled) => {
    if (isDisabled) {
      setSelectedDisabledCounter((prevState) => prevState + 1)
    }
  }
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        width: '100%',
        gap: 1,
      }}
    >
      {/* MONTH TITLE */}
      <Box width={1} display="flex" alignItems="flex" justifyContent="center" height="35px" py={1}>
        <Typography variant="body1" fontWeight={700}>
          {format(value, `MMMM yyyy`)}
        </Typography>
      </Box>

      {/* DAYS TITLE*/}
      <Box width={1} height={'45px'} display="flex" flexWrap="wrap">
        {dayofWeek.map((day) => (
          <Box
            key={day}
            sx={{
              width: 'calc(100% / 7)',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="light-gray-text.main">
              {day}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* DATE */}
      <Box width={1} display="flex" flexWrap="wrap">
        {calendar.map((day, index) => {
          // THIS IS TO OFFSET 1ST DATE AND DAY
          if (index === 0) {
            return (
              <Fragment key={index}>
                {Array.from({ length: day.hari }, (_, k) => (
                  <Box key={k} sx={{ width: 'calc(100% / 7)', height: '45px' }} />
                ))}
                <DayDiv
                  day={day}
                  value={value}
                  calendarProps={calendarProps}
                  handleClick={handleClick}
                  clickState={clickState}
                  selectedFirst={selectedFirst}
                  selectedSecond={selectedSecond}
                  getSelectedDisabledCount={getSelectedDisabledCount}
                />
              </Fragment>
            )
          }

          // THIS IS THE REST OF THE DATE
          return (
            <DayDiv
              key={index}
              day={day}
              value={value}
              calendarProps={calendarProps}
              handleClick={handleClick}
              clickState={clickState}
              selectedFirst={selectedFirst}
              selectedSecond={selectedSecond}
              getSelectedDisabledCount={getSelectedDisabledCount}
            />
          )
        })}
      </Box>
    </Box>
  )
}

export default CalendarBlock
